import React from 'react';
import { Linkedin, Mail, MapPin, ArrowUp, Phone } from 'lucide-react';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer id="footer" className="bg-[#1A2030] text-white py-14" data-id="element-152">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-153">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-154">
          {/* Brand */}
          <div data-id="element-155">
            <h2 className="text-xl font-bold mb-4 tracking-tight" data-id="element-156">
              PETER SHELDON
            </h2>
            <p className="text-[#B8B0A4] max-w-xs leading-relaxed text-sm" data-id="element-157">
              Senior Program Manager specializing in strategic transformation
              and operational excellence for global enterprises.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-158">
            <h3 className="text-base font-semibold mb-5 text-corporate-teal" data-id="element-159">
              Quick Links
            </h3>
            <ul className="space-y-2.5" data-id="element-160">
              <li data-id="element-161">
                <a href="#hero" className="text-[#B8B0A4] hover:text-white transition-colors text-sm" data-id="element-162">
                  Home
                </a>
              </li>
              <li data-id="element-163">
                <a href="#pillars" className="text-[#B8B0A4] hover:text-white transition-colors text-sm" data-id="element-164">
                  Expertise
                </a>
              </li>
              <li data-id="element-165">
                <a href="#experience" className="text-[#B8B0A4] hover:text-white transition-colors text-sm" data-id="element-166">
                  Experience
                </a>
              </li>
              <li data-id="element-167">
                <a href="https://heyzine.com/flip-book/779702ad6e.html" target="_blank" rel="noopener noreferrer" className="text-[#B8B0A4] hover:text-white transition-colors text-sm" data-id="element-168">
                  Resume
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-169">
            <h3 className="text-base font-semibold mb-5 text-corporate-teal" data-id="element-170">
              Contact
            </h3>
            <ul className="space-y-3" data-id="element-171">
              <li className="flex items-center text-[#B8B0A4] text-sm" data-id="element-172">
                <Mail size={18} className="mr-3 text-corporate-teal" data-id="element-173" />
                <a href="mailto:psheldon22@gmail.com" className="hover:text-white transition-colors" data-id="element-174">
                  psheldon22@gmail.com
                </a>
              </li>
              <li className="flex items-center text-[#B8B0A4] text-sm" data-id="element-175">
                <Linkedin size={18} className="mr-3 text-corporate-teal" data-id="element-176" />
                <a href="https://www.linkedin.com/in/peter-sheldon-aaa84225/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-177">
                  LinkedIn Profile
                </a>
              </li>
              <li className="flex items-center text-[#B8B0A4] text-sm" data-id="element-178">
                <MapPin size={18} className="mr-3 text-corporate-teal" data-id="element-179" />
                <span data-id="element-180">West Hartford, Connecticut, US</span>
              </li>
              <li className="flex items-center text-[#B8B0A4] text-sm" data-id="element-181">
                <Phone size={18} className="mr-3 text-corporate-teal" data-id="element-182" />
                <a href="tel:8607594995" className="hover:text-white transition-colors" data-id="element-183">
                  (860) 759-4995
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-184">
          <p className="text-[#9A9184] text-sm mb-4 md:mb-0" data-id="element-185">
            &copy; {new Date().getFullYear()} Peter Sheldon. All rights
            reserved.
          </p>

          <button onClick={scrollToTop} className="flex items-center text-sm text-[#B8B0A4] hover:text-white transition-colors group" data-id="element-186">
            Back to Top
            <ArrowUp size={16} className="ml-2 group-hover:-translate-y-1 transition-transform" data-id="element-187" />
          </button>
        </div>
      </div>
    </footer>;
}